import { IMedia, pxToRem } from "@/util";
import { Box, Paper, Typography } from "@mui/material";
import React from "react";
import { makeStyles } from "tss-react/mui";
import Image from "next/image";
import { FeaturedCarousel } from "../home/featuredCarousel";
type props = {
  media: Partial<IMedia>[];
};
export default function PortfolioCard({ media }: Partial<props>) {
  const { classes } = styles();
  return (
    <Paper className={classes.container}>
      <Box className={classes.slide}>
        <FeaturedCarousel>
          {media ? (
            media.map((_, key) => {
              return (
                <Box key={key} className={classes.card}>
                  <Box className={classes.img}>
                    <Image
                      src={_.url || "/default-image.jpg"}
                      alt="Featured House"
                      fill
                      objectFit="cover"
                    />
                  </Box>
                  <Box className={classes.overlay}></Box>
                </Box>
              );
            })
          ) : (
            <Box className={classes.card}>
              <Typography>No Media</Typography>
            </Box>
          )}
        </FeaturedCarousel>
      </Box>
    </Paper>
  );
}

const styles = makeStyles()((theme) => ({
  container: {
    height: pxToRem(491),
    width: "100%",
    borderRadius: pxToRem(24),
    display: "flex",
    flexDirection: "column",
    overflow: "hidden",
     [theme.breakpoints.down(860)]:{
      height:pxToRem(300),
      
    }
  },
  slide: {
    display: "flex",
    borderRadius: pxToRem(12),
    flex: 1,
    overFlow: "hidden",
    position: "relative",
   
  },
  card: {
    position: "relative",
    width: "100%",
    display: "flex",
    height: "100%",
    flex: 1,
    alignItems: "center",
    justifyContent: "center",
  },
  overlay: {
    position: "absolute",
    background: "linear-gradient(to top, #00000080, #00000040, #00000000)",
    width: "100%",
    height: "100%",
  },
  img: {
    width: "100%",
    display: "flex",
    flex: 1,
  },
  footer: {
    height: pxToRem(170),
    padding: theme.spacing(3),
    width: "100%",
    display: "flex",
    alignSelf: "end",
    position: "relative",
    zIndex: 10,
    flexDirection: "column",
    gap: theme.spacing(2),
  },
  footHead: {
    display: "flex",
    flexDirection: "row",
    gap: theme.spacing(3),
    alignItems: "center",
  },
  footName: {
    fontFamily: "Playfair Display",
    fontWeight: 700,
    fontSize: pxToRem(30),
    color: theme.colors.white,
  },
  footLoc: {
    fontFamily: "Playfair Display",
    fontWeight: 400,
    fontSize: pxToRem(24),
    color: theme.colors.white,
  },
  footDes: {
    fontWeight: 500,
    fontSize: pxToRem(20),
    color: theme.colors.white,
  },
  footDet: {
    fontWeight: 400,
    fontSize: pxToRem(16),
    color: theme.colors.white,
    width: "85%",
  },
}));
